// GENERATED CODE - DO NOT EDIT
export const SectionTypeMap = {
    UPCOMING_SHIPMENTS: 'UPCOMING_SHIPMENTS',
    NEW_PRESCRIPTIONS: 'NEW_PRESCRIPTIONS',
    PENDING_TRANSFERS: 'PENDING_TRANSFERS',
    DUE_FOR_REFILL: 'DUE_FOR_REFILL',
    PATIENT_TASK: 'PATIENT_TASK',
    OUT_OF_REFILLS: 'OUT_OF_REFILLS',
    MED_SYNC_UPSELL: 'MED_SYNC_UPSELL',
    DELIVERED_SHIPMENTS: 'DELIVERED_SHIPMENTS',
    FEATURED_OTCS: 'FEATURED_OTCS',
    CLOSED_TRANSFERS: 'CLOSED_TRANSFERS',
    APP_PROMOS: 'APP_PROMOS',
    INSTRUCTIONAL_VIDEOS: 'INSTRUCTIONAL_VIDEOS',
    UNBOXING_GUIDE: 'UNBOXING_GUIDE',
};
//# sourceMappingURL=section_type.js.map